import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DispatcherClass;
function Dispatcher() {
  if (DispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Dispatcher', VOID, VOID, VOID, [1]);
    DispatcherClass = $;
  }
  return DispatcherClass;
}
var SavePlayerCommandClass;
function SavePlayerCommand() {
  if (SavePlayerCommandClass === VOID) {
    class $ {
      constructor(partyId, player) {
        this.i2n_1 = partyId;
        this.j2n_1 = player;
      }
      toString() {
        return 'SavePlayerCommand(partyId=' + this.i2n_1.toString() + ', player=' + this.j2n_1.toString() + ')';
      }
      hashCode() {
        var result = this.i2n_1.hashCode();
        result = imul(result, 31) + this.j2n_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePlayerCommand()))
          return false;
        if (!this.i2n_1.equals(other.i2n_1))
          return false;
        if (!this.j2n_1.equals(other.j2n_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePlayerCommand');
    SavePlayerCommandClass = $;
  }
  return SavePlayerCommandClass;
}
//region block: exports
export {
  Dispatcher as Dispatcher39hthxqv8voqz,
  SavePlayerCommand as SavePlayerCommand2ifdfeyjpvr4j,
};
//endregion

//# sourceMappingURL=SavePlayerCommand.mjs.map
